import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import "../css/Agevolazioni.css";
import "../css/global.css";
import InfoBox from "../components/InfoBox";
import API from "../config/api";
// Fallback to static FAQ if API fails
import staticFaqBonusInfissi from "../data/faqBonusInfissi";

const Agevolazioni = () => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const [faqBonusInfissi, setFaqBonusInfissi] = useState(staticFaqBonusInfissi);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaq = async () => {
      try {
        const response = await fetch(API.ENDPOINTS.FAQ);
        const data = await response.json();
        // Validate that data is an array with FAQ items
        if (Array.isArray(data) && data.length > 0 && data[0].title) {
          setFaqBonusInfissi(data);
        }
      } catch (error) {
        console.error("Error fetching FAQ:", error);
        // Keep static FAQ as fallback
      } finally {
        setLoading(false);
      }
    };

    fetchFaq();
  }, []);

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

  return (
    <div>
      <Navbar />
      <div className="agevolazioni-container">
        <h1>Agevolazioni Fiscali 2025</h1>
        <p className="agevolazioni-intro">
          Scopri tutti i bonus edilizi disponibili nel 2025 per la sostituzione
          di infissi, l'installazione di porte blindate e sistemi di sicurezza.
          Per l'abitazione principale la detrazione è del 50%, per le seconde
          case del 36%.
        </p>

        <div className="faq-section">
          <h2 className="faq-title">Domande Frequenti - Bonus Edilizi 2025</h2>
          
          {loading ? (
            <div className="loading-message">Caricamento FAQ...</div>
          ) : (
            <div className="accordion-container">
              {faqBonusInfissi.map((faq) => (
                <div
                  key={faq.id}
                  className={`accordion-item ${
                    openAccordion === faq.id ? "active" : ""
                  }`}
                >
                  <button
                    className="accordion-header"
                    onClick={() => toggleAccordion(faq.id)}
                    aria-expanded={openAccordion === faq.id}
                    aria-controls={`accordion-content-${faq.id}`}
                  >
                    <span className="accordion-title">{faq.title}</span>
                    <span className="accordion-icon">
                      {openAccordion === faq.id ? "−" : "+"}
                    </span>
                  </button>
                  <div
                    id={`accordion-content-${faq.id}`}
                    className="accordion-content"
                    style={{
                      maxHeight: openAccordion === faq.id ? "1000px" : "0",
                    }}
                  >
                    <div className="accordion-body">
                      <p>{faq.description}</p>
                      {faq.links && faq.links.length > 0 && (
                        <div className="accordion-links">
                          <span className="links-label">Fonti ufficiali:</span>
                          <ul>
                            {faq.links.map((link, index) => (
                              <li key={index}>
                                <a
                                  href={link.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {link.label}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="agevolazioni-footer">
          <InfoBox />
        </div>
      </div>
    </div>
  );
};

export default Agevolazioni;
